import React, { useState } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import LanguageSwitch from '../components/LanguageSwitch';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeasonalTheme } from '../contexts/SeasonalThemeContext';
import { 
    FaBars, FaChartPie, FaTooth, FaUserInjured, 
    FaFileInvoiceDollar, FaUserCircle, FaCog 
} from 'react-icons/fa';
import '../styles/MainLayout.css';

const MainLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { isAdmin, isProducer } = useAuth();
    const { t } = useLanguage();
    const { isSeasonalActive, currentThemeId, themeMeta } = useSeasonalTheme();
    const isBlackFriday = currentThemeId === 'blackfriday';

    // Bottom nav items based on role (matching the inspired design)
    const getBottomNavItems = () => {
        if (isProducer) {
            return [
                { path: '/jobs', name: t('nav.jobs', 'Travaux'), icon: <FaTooth /> },
                { path: '/profile', name: t('nav.profile', 'Profil'), icon: <FaUserCircle /> }
            ];
        }
        return [
            { path: '/dashboard', name: t('nav.dashboard', 'Dashboard'), icon: <FaChartPie /> },
            { path: '/jobs', name: t('nav.jobs', 'Travaux'), icon: <FaTooth /> },
            { path: '/clients', name: t('nav.clients', 'Praticiens'), icon: <FaUserInjured /> },
            { path: '/accounting', name: t('nav.accounting', 'Compta'), icon: <FaFileInvoiceDollar /> },
            { path: '/profile', name: t('nav.profile', 'Profil'), icon: <FaUserCircle /> }
        ];
    };

    const navItems = getBottomNavItems();

    return (
        <div className="main-layout">
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            
            {/* Backdrop overlay for mobile */}
            {sidebarOpen && (
                <div 
                    className="sidebar-overlay" 
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}

            <div className="main-content-wrapper">
                {/* Mobile Top Header */}
                <div className="mobile-header">
                    <span className="mobile-logo d-flex align-items-center gap-2">
                        ENOVADENT
                        {isSeasonalActive && (
                            <span className="seasonal-banner-badge" style={{ fontSize: '0.8rem' }}>
                                {themeMeta.icon}
                            </span>
                        )}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <LanguageSwitch compact={true} />
                        <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)}>
                            <FaBars />
                        </button>
                    </div>
                </div>

                {isBlackFriday && (
                    <div className="bf-top-promo-banner">
                        <span className="bf-promo-gold">ÉVÉNEMENT BLACK FRIDAY</span>
                        <span className="bf-promo-sep"> - </span>
                        <span className="bf-promo-red">OFFRES EXCEPTIONNELLES !</span>
                    </div>
                )}

                <div className="main-content">
                    <Outlet />
                </div>

                {/* Mobile Bottom Navigation Bar */}
                <div className="mobile-bottom-nav">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) => `mobile-bottom-nav-item ${isActive ? 'active' : ''}`}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-label">{item.name}</span>
                        </NavLink>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MainLayout;
